module.exports = __webpack_public_path__ + "img/Logo-ICFA-strapi.aae1f3c.png";